import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col,Spinner,Alert } from "reactstrap";
import { bindActionCreators } from 'redux';

import { requestData, getData, getInfo } from 'core/ducks/list';
import { postData } from 'core/ducks/update';
import { ErrorPage } from "core/views/pages";
import { Loading } from "core/components";
import {
    Filter, FilterGroup, Table, Title, Button, Tbody, Thead, Toolbox, Tr, Search, Pagination, Checkbox
} from "table";
import * as roles from 'core/model/roles';
import { StaticRoutes } from '../../model/routes';
import applicationRoles from '../../model/appRoles';
import withApp from "./app";
import { default as T } from 'modules/i18n';
import { ChargeApplicationModal, ViewLicence } from "../modals";
import { toggleModal } from 'core/ducks/ui/modal';
import axios from 'axios';

const LICENCE_EXTRA_DATA_FIELDS = [
    'kind', 'station_id', 'licence_number', 'external_url_link', 'issue_date', 'licence_status',
    'primary_registry', 'initiated_date', 'status_label_descr', 'org_identifier', 'org_name_mitroo',
    'org_name', 'org_title', 'org_address', 'legal_representative', 'proxy_identifier', 'proxy_fullname',
    'proxy_phonenumber', 'proxy_email', 'region', 'regional_section', 'municipality', 'municipal_section',
    'position', 'technology_ape', 'technology', 'technology_storage', 'is_special', 'inst_mw', 'mw',
    'guar_power', 'max_pwr_eg', 'max_pwr_ap', 'egk_capac', 'guar_capac', 'max_production_capacity_kwhth',
    'inst_mw2', 'mw2', 'expiration_date', 'renewal_expiration_date', 'suspended', 'suspension_date',
    'cert_number', 'mod_decisions', 'progress_reports', 'is_modified', 'modified_by',
];

const TECHNOLOGY_APE_TO_PSAPE = {
    'ΑΙΟΛΙΚΑ': 4,
    'ΒΙΟΜΑΖΑ': 7,
    'ΦΩΤΟΒΟΛΤΑΪΚΑ': 8,
    'Σ.Η.Θ.Υ.Α.': 2,
    'ΜΕΓΑΛΑ ΥΔΡΟΗΛΕΚΤΡΙΚΑ': 3,
    'ΜΥΗΕ': 5,
    'ΓΕΩΘΕΡΜΙΑ': 6,
    'ΗΛΙΟΘΕΡΜΙΚΑ': 9,
    'ΥΒΡΙΔΙΚΑ ΑΠΕ': 11,
    'ΦΩΤΟΒΟΛΤΑΪΚΑ + ΑΙΟΛΙΚΑ': 12,
    'ΦΩΤΟΒΟΛΤΑΪΚΑ + ΜΥΗΕ': 13,
    'ΑΠΟΘΗΚΕΥΣΗ': 15,
};

class Licence extends Component {

    constructor(props) {
        super(props);
        this.initialState = {
			query: '',
			status: '',
			sort: 'issue_date',
			sort_method: 'desc',
			httpStatus: 200
		};
        const { params } = props.match;
		const initialize = {
			status: (params && params.status) ? params.status : '',
		};
		this.state = { 
            ...this.initialState, 
            ...initialize, 
            page: 1, 
            refreshing: false, 
            selectedLicence: {}, 
            isChargeModalOpen: false,
            loading: false,
            monthlyLoading: false,
            selectedMonth: new Date().getMonth() + 1, // Current month (1-12)
            selectedYear: new Date().getFullYear() // Current year
        };

        this.fields = props.profile.role === roles.AUTHORIZED
            ? ['kind','station_id', 'licence_number', 'external_url_link', 'issue_date', 'licence_status', 'primary_registry', 'initiated_date', 'status_label_descr', 'org_identifier', 'org_name_mitroo', 'org_name', 'org_title', 'org_address', 'legal_representative', 'proxy_identifier', 'proxy_fullname', 'proxy_phonenumber', 'proxy_email', 'region', 'regional_section', 'municipality', 'municipal_section', 'position', 'technology_ape', 'technology', 'technology_storage', 'is_special', 'inst_mw', 'mw', 'guar_power', 'max_pwr_eg', 'max_pwr_ap', 'egk_capac', 'guar_capac', 'max_production_capacity_kwhth', 'inst_mw2', 'mw2', 'expiration_date', 'renewal_expiration_date', 'suspended', 'suspension_date', 'cert_number', 'mod_decisions', 'progress_reports', 'is_modified', 'modified_by']
            : ['kind','station_id', 'licence_number', 'external_url_link', 'issue_date', 'licence_status', 'primary_registry', 'initiated_date', 'status_label_descr', 'org_identifier', 'org_name_mitroo', 'org_name', 'org_title', 'org_address', 'legal_representative', 'proxy_identifier', 'proxy_fullname', 'proxy_phonenumber', 'proxy_email', 'region', 'regional_section', 'municipality', 'municipal_section', 'position', 'technology_ape', 'technology', 'technology_storage', 'is_special', 'inst_mw', 'mw', 'guar_power', 'max_pwr_eg', 'max_pwr_ap', 'egk_capac', 'guar_capac', 'max_production_capacity_kwhth', 'inst_mw2', 'mw2', 'expiration_date', 'renewal_expiration_date', 'suspended', 'suspension_date', 'cert_number', 'mod_decisions', 'progress_reports', 'is_modified', 'modified_by'];

        this.layout = {
            kind: { sortable: true },
            station_id: { sortable: true },
            status_label: { sortable: true },
            status_label_descr: { sortable: true },
            licence_number: { sortable: true },
			external_url_link: { type: 'link', sortable: true },
            primary_registry: { sortable: true },
            initiated_date: { type: 'date', sortable: true },
            issue_date: { type: 'date', sortable: true },
            org_name_mitroo: { sortable: true },
            org_name: { sortable: true },
            org_title: { sortable: true },
            is_special: { type: 'boolean', sortable: true },
            expiration_date: { type: 'date', sortable: true },
            renewal_expiration_date: { type: 'date', sortable: true },
            suspended: { type: 'boolean', sortable: true, label: 'licence_suspended' },
            suspension_date: { type: 'date', sortable: true },
            cert_number: { sortable: true },
            mod_decisions: { type: 'array', sortable: false },
            progress_reports: { type: 'array', sortable: false },
            region: { sortable: true },
            regional_section: { sortable: true },
            municipality: { sortable: true },
            municipal_section: { sortable: true },
            position: { sortable: true },
            licence_status: { sortable: true },
            inst_mw: { sortable: true },
            mw: { sortable: true },
            guar_power: { sortable: true },
            max_pwr_eg: { sortable: true },
            max_pwr_ap: { sortable: true },
            egk_capac: { sortable: true },
            guar_capac: { sortable: true },
            max_production_capacity_kwhth: { sortable: true },
            inst_mw2: { sortable: true },
            mw2: { sortable: true },
            technology_ape: { sortable: true },
            technology: { sortable: true },
            technology_storage: { sortable: true },
            proxy_identifier: { sortable: true },
            proxy_fullname: { sortable: true },
            proxy_phonenumber: { sortable: true },
            proxy_email: { sortable: true },
            org_address: { sortable: true },
            legal_representative: { sortable: true },
            org_identifier: { sortable: true },
            is_modified: { type: 'boolean', sortable: true },
            modified_by: { sortable: true }
        };

        this.fetchData = this.fetchData.bind(this);
        this.fetchStationProfile = this.fetchStationProfile.bind(this);
        this.buildStationUpdatePayload = this.buildStationUpdatePayload.bind(this);
        this.updateStation = this.updateStation.bind(this);
		this.createUrl = this.createUrl.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.handleFilterChange = this.handleFilterChange.bind(this);
		this.handleToolboxReset = this.handleToolboxReset.bind(this);

        const { dispatch } = props;
        this.actions = bindActionCreators({toggleModal}, dispatch);

        // Month names for dropdown
        this.monthNames = [
            'january', 'february', 'march', 'april', 'may', 'june',
            'july', 'august', 'september', 'october', 'november', 'december'
        ];
    }

    componentDidMount() {
        this.fetchData();
    }

	componentDidUpdate(prevProps, prevState) {
		const { params } = this.props.match;
		if (
			params.status !== prevProps.match.params.status ||
			prevState.query !== this.state.query
		) {
			let state = { page: 1 };
			if (prevState.query !== this.state.query)
				state = Object.assign(state, { query: this.state.query });
			this.setState(state, this.fetchData);
		}
	}

    fetchStationProfile(stationId, filter) {
        if (!stationId || !filter) {
            return Promise.resolve([]);
        }
        const url = `app/station-profile/stationId/${stationId}/filter/${filter}`;
        return this.props.dispatch(
            requestData('station_profile', url)
        ).then((data) => {
            return data;
        });
    }

    parsePower(value) {
        if (value === null || value === undefined || value === '') {
            return undefined;
        }
        const parsed = parseFloat(String(value).replace(',', '.'));
        return Number.isFinite(parsed) ? parsed : undefined;
    }

    getStationFromProfile(stationProfile) {
        const raw = stationProfile && stationProfile.stationData;
        if (!raw) {
            return null;
        }
        if (Array.isArray(raw)) {
            return raw.length > 0 ? raw[0] : null;
        }
        if (Array.isArray(raw.value)) {
            return raw.value.length > 0 ? raw.value[0] : null;
        }
        if (raw.stationId || raw.stationid) {
            return raw;
        }
        return null;
    }

    resolveStationId(licence) {
        if (!licence || licence.station_id === null || licence.station_id === undefined) {
            return null;
        }
        const stationId = String(licence.station_id).trim();
        return stationId !== '' ? stationId : null;
    }

    buildLicenceExtraData(licence) {
        const extra = {};
        LICENCE_EXTRA_DATA_FIELDS.forEach((field) => {
            if (licence && Object.prototype.hasOwnProperty.call(licence, field)) {
                extra[field] = licence[field];
            }
        });
        return JSON.stringify(extra);
    }

    buildStationUpdatePayload(licence, stationProfile) {
        const stationId = this.resolveStationId(licence);
        if (!stationId) {
            return null;
        }

        const station = this.getStationFromProfile(stationProfile);
        const technologyKey = licence.technology_ape
            ? String(licence.technology_ape).trim().toUpperCase()
            : '';

        let stationTechnologyId = station && (station.stationTechnologyId ?? station.technologyId);
        if (stationTechnologyId != null && stationTechnologyId !== '') {
            stationTechnologyId = parseInt(stationTechnologyId, 10);
        } else if (technologyKey && TECHNOLOGY_APE_TO_PSAPE[technologyKey]) {
            stationTechnologyId = TECHNOLOGY_APE_TO_PSAPE[technologyKey];
        } else {
            stationTechnologyId = undefined;
        }

        const payload = {
            SystemId: 2,
            TransactionTypeId: 2,
            StationId: stationId,
        };

        const optional = {
            RegionCode: licence.region || (station && station.region),
            RegionalUnitCode: licence.regional_section || (station && station.regionSection),
            MunicipalityCode: licence.municipality || (station && station.municipality),
            MunicipalUnitCode: licence.municipal_section || (station && station.municipalitySection),
            InstalledPower: this.parsePower(licence.inst_mw ?? (station && station.installedPower)),
            MaxPower: this.parsePower(licence.mw ?? (station && station.maxPower)),
            ClientVatNumber: licence.org_identifier,
            ClientName: licence.org_name || licence.org_name_mitroo,
            LicenseNumber: licence.licence_number,
            StationTechnologyId: stationTechnologyId,
        };

        Object.entries(optional).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                payload[key] = value;
            }
        });

        payload.ExtraData = this.buildLicenceExtraData(licence);

        return payload;
    }

    updateStation(licence, stationProfile) {
        if (!this.resolveStationId(licence)) {
            return Promise.reject(new Error('Δεν υπάρχει κωδικός σταθμού για ενημέρωση.'));
        }

        const payload = this.buildStationUpdatePayload(licence, stationProfile);
        if (!payload) {
            return Promise.reject(new Error('Δεν ήταν δυνατή η δημιουργία του payload ενημέρωσης.'));
        }

        return this.props.dispatch(
            postData('app/station-update', payload, true)
        );
    }

    fetchData = () => {
        const url = this.createUrl();
		this.props.dispatch(
			requestData('licence', url)
		).catch(httpStatus => {
			this.setState({ httpStatus });
		});
    }

    createUrl = (base_url='app/licence') => {
        let { query, sort, sort_method } = this.state;
        let url = base_url === 'app/licence' ? `${base_url}/page/${this.state.page}` : base_url;
        url = `${url}/sort/${sort}/sort_method/${sort_method}`;
        query = (query !== '') ? '/query/' + query : '';
        url += query;

        return url;
    }

	handlePageChange(page) {
		this.setState({ page }, this.fetchData);
	}

	handleFilterChange(event) {
		this.setState({
			[event.target.name]: event.target.value,
			page: 1
		}, () => {
			let url = StaticRoutes.Licenses;
			if (this.props.profile.role !== roles.AUTHORIZED) {
				url = StaticRoutes.AdminLicenses;
			}
			this.props.history.push(url);
		});
	}

	handleToolboxReset() {
		this.setState({
			...this.initialState,
			page: 1
		}, this.fetchData);
		let url = StaticRoutes.Licenses;
		if (this.props.profile.role !== roles.AUTHORIZED) {
			url = StaticRoutes.AdminLicenses;
		}
		this.props.history.push(url);
	}

    handleSortChange = (sort) => {
        if (sort === this.state.sort) {
            this.setState({ sort_method: this.state.sort_method === 'asc' ? 'desc' : 'asc' }, this.fetchData);
        } else {
            this.setState({ sort }, this.fetchData);
        }
    }

    handleStaticExport = async () => {
	
		// Build the URL using this.createUrl() and add the export string at the end
		const url = `${this.createUrl('/api/app/licence')}/export/xlsx`;
	
        this.setState({
            loading: true,
        });
        // console.log(url);
		try {
            //   Simulate a 3-second delay (instead of downloading the file)
            // await new Promise((resolve) => setTimeout(resolve, 4000));

            // // After the delay, set loading to false
            // this.setState({ loading: false });
            // console.log("File processing complete, loading finished.");
            await this.downloadXLSFile(url);
		} catch (error) {
            this.setState({
                loading: false,
            });
		    console.error('Error downloading the file', error);
		} 
	};

    // Generate month-year string (e.g., "june_2024")
    generateMonthYearString = () => {
        const { selectedMonth, selectedYear } = this.state;
        const monthName = this.monthNames[selectedMonth - 1];
        return `${monthName}_${selectedYear}`;
    };

    handleMonthlyExport = async () => {
        
        const url = `${this.createUrl('/api/app/licence')}/export/monthly`;
        
        this.setState({
            monthlyLoading: true,
        });
        
        try {
            await this.downloadXLSFile(url, true);
        } catch (error) {
            this.setState({
                monthlyLoading: false,
            });
            console.error('Error downloading the monthly file', error);
        } 
    };

    downloadXLSFile = async (url, isMonthly = false, period = null) => {
        const config = {
            method: 'GET',
            url: url,
            responseType: 'arraybuffer', // Important for binary data
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            },
            timeout: 600000, // Set timeout to 60 seconds (60000 ms), adjust as needed
        };

        try {
            const response = await axios(config);

            if (isMonthly) {
                // For monthly export, handle multiple files
                await this.handleMultipleFileDownload(response.data);
            } else {
                // Single file download for regular export
                await this.handleSingleFileDownload(response.data, false);
            }
            
            this.setState({
                loading: false,
                monthlyLoading: false,
            });
        } catch (error) {
            this.setState({
                loading: false,
                monthlyLoading: false,
            });
            console.error('Error downloading the file', error);
        }
    };

    handleSingleFileDownload = async (data, isMonthly = false) => {
        // Create a blob from the response data
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            
        // Create a link element to trigger download
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        
        let filename;
        if (isMonthly) {
            // Use month_year format for monthly export
            const monthYearString = this.generateMonthYearString();
            filename = `licences_${monthYearString}.xlsx`;
        } else {
            // Use date format for regular export
            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();
            const formattedDate = `${day}-${month}-${year}`;
            filename = `licences_${formattedDate}.xlsx`;
        }

        // Set the filename
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    };

    handleMultipleFileDownload = async (responseData) => {
        // Assuming the response contains multiple files or file information
        // This is a simplified example - you may need to adjust based on your actual API response structure
        
        try {
            // If the response is a ZIP file containing multiple Excel files
            if (responseData instanceof ArrayBuffer) {
                // Handle as a single ZIP file that the browser will download
                const blob = new Blob([responseData], { type: 'application/zip' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                
                const monthYearString = this.generateMonthYearString();
                link.setAttribute('download', `licences_${monthYearString}_bundle.zip`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
            }
            
            // Alternative: If you receive URLs or individual file data in JSON format
            // You would parse the response and download each file individually with delays
            // Example:
            // const files = JSON.parse(responseData);
            // for (let i = 0; i < files.length; i++) {
            //     setTimeout(() => {
            //         this.downloadIndividualFile(files[i], i);
            //     }, i * 1000); // 1 second delay between downloads
            // }
            
        } catch (error) {
            console.error('Error handling multiple file download:', error);
        }
    };

    handleMonthChange = (event) => {
        this.setState({
            selectedMonth: parseInt(event.target.value)
        });
    };

    handleYearChange = (event) => {
        this.setState({
            selectedYear: parseInt(event.target.value)
        });
    };

    // Generate year options (current year ± 5 years)
    generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear - 5; i <= currentYear + 5; i++) {
            years.push(i);
        }
        return years;
    };

    render() {
        const { data, info, list } = this.props;
		if (this.state.httpStatus !== 200)
			return (<ErrorPage status={this.state.httpStatus} />);
		if (list.licence.status !== 200 && list.licence.status !== '')
			return (<ErrorPage status={list.licence.status} />);
        const currentPage = Number.isFinite(Number(info && info.page)) && Number(info.page) > 0
            ? Number(info.page)
            : 1;
        const totalPages = Number.isFinite(Number(info && info.total_pages)) && Number(info.total_pages) > 0
            ? Number(info.total_pages)
            : 1;
        
        const { messages } = this.props.i18n || { messages: {} };
		const { loading, monthlyLoading, selectedMonth, selectedYear } = this.state;

        return (
            <Row>
                <Col>
                    <Table>
                        <Title>
                            <T>licenses</T>
                            <Button type="toolbox" title="filters" className="float-right" />
                        </Title>
                        <Toolbox onReset={this.handleToolboxReset}>
							<Row>
								<Col xs="12" lg="12" className="form-group text-right">
									<Search placeholder={`${messages.licence_number} ή ${messages.primary_registry} ή ${messages.position}`} onChange={this.handleFilterChange} name="query" />
                                    {loading && (
                                        <div>
                                            <Loading />
                                            <Alert color="info" className="mb-0 text-center">
                                                <T>please_wait_message</T>
                                            </Alert>                                    
                                        </div>
                                    )}
                                    {monthlyLoading && (
                                        <div>
                                            <Loading />
                                            <Alert color="info" className="mb-0 text-center">
                                                <T>please_wait_message</T>
                                            </Alert>                                    
                                        </div>
                                    )}                                    
                                    {[roles.ADMIN, roles.EDITOR, roles.REVIEWER].includes(this.props.user.role) && (
                                        <>
                                            {/* Monthly Export Section - Left side */}
                                            <div className="d-inline-block mr-3" style={{ verticalAlign: 'top' }}>
                                                <div className="d-flex align-items-center" style={{ gap: '8px' }}>
                                                    <Button type="xlsx"  title={`.${messages.export_monthly || 'export'} .xlsx`} className="mx-2" onClick={this.handleMonthlyExport} disabled={monthlyLoading}>
                                                        <T>export_monthly</T> 
                                                    </Button>
                                                </div>
                                            </div>
                                            
                                            {/* Regular Export Button - Right side */}
                                            <Button type="xlsx" title={`.${messages.export || 'export'} .xlsx`} className="mx-2" onClick={this.handleStaticExport}>
                                                <T>export</T> .xlsx
                                            </Button>
                                        </>
                                    )}
                                    <Button type="resetFilters" title={messages['reset filters'] || 'reset filters'}><T>reset</T></Button>
								</Col>
							</Row>
						</Toolbox>
                        <Thead>
                            <Tr
                                className="text-capitalize"
                                data={['', ...this.fields]}
                                layout={{...this.layout}}
                                sortBy={this.state.sort}
                                sortMethod={this.state.sort_method}
                                onClick={this.handleSortChange}
                            />
                        </Thead>
                        {
                            this.props.pending || !data ? <Loading /> :
                                <Tbody refreshing={this.state.refreshing}>
                                    <Tr
                                        data={data ? data : {}}
                                        layout={{...this.layout}}
                                        order={[...this.fields]}
                                    >
                                        <Button
                                            type="view"
                                            title={messages.view || 'view'}
                                            onClick={(data) => {
                                                this.actions.toggleModal(
                                                    true,
                                                    <ViewLicence
                                                        data={data}
                                                        fetchStationProfile={this.fetchStationProfile}
                                                        updateStation={this.updateStation}
                                                    />
                                                );
                                            }}
                                        />
                                        {this.props.appRoles.includes(applicationRoles.ADMINISTRATOR) &&
                                            <Button type="user-plus" title={messages.charge || 'charge'} onClick={(selectedLicence) => this.setState({isChargeModalOpen: true, selectedLicence})} />
                                        }
                                    </Tr>
                                </Tbody>
                        }
						<Pagination
							className="mx-auto"
							page={currentPage}
							total={totalPages}
							onClick={(page) => {
								if (page !== currentPage)
									this.handlePageChange(page);
							}}
						/>
                    </Table>
                    { this.state.isChargeModalOpen &&
                        <ChargeApplicationModal
                            isOpen={this.state.isChargeModalOpen}
                            cancel={() => this.setState({isChargeModalOpen: false})}
                            toggle={() => {
                                this.setState({isChargeModalOpen: false});
                                this.fetchData();
                            }}
                            application={this.state.selectedLicence.index}
                            registry_number={this.state.selectedLicence.licence_number}
                            current={this.state.selectedLicence.proxy_user}
                            scope='licence'
                        />
                    }
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = (state) => ({
    profile: state.profile.user,
    i18n: state.i18n,
	list: state.list,
	pending: state.list.licence.pending,
	data: getData(state, 'licence'),
	info: getInfo(state, 'licence'),
	viewData: state.update.response,
	http_status: state.update.status,
    user: state.profile.user
});

Licence = connect(mapStateToProps)(Licence);
export default withApp(Licence);